import '../css/funds.css';

export default function Funds() {
    const isMobile = window.innerWidth <= 768;

    return(
        <div className="funds">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="facts-item">
                                <svg height={isMobile?40:80} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#FFD43B" d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" /></svg>
                                <div className="facts-text">
                                    <h3 className="facts-plus" data-toggle="counter-up">2</h3>
                                    <p>Countries</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="facts-item">
                                <svg height={isMobile?40:80} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#FFD43B" d="M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z" /></svg>
                                <div className="facts-text">
                                    <h3 className="facts-plus" data-toggle="counter-up">500</h3>
                                    <p>Volunteers</p>
                                </div>
                            </div>
                        </div>
                       <div className="col-lg-3 col-md-6">
  <div className="facts-item">
    <svg height={isMobile?35:70} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
      <path fill="#FFD43B" d="M256 0a112 112 0 1 1 0 224A112 112 0 1 1 256 0zM160 224h192c53 0 96 43 96 96v128c0 35-29 64-64 64h-48V352h-32v160h-96V352h-32v160h-48c-35 0-64-29-64-64V320c0-53 43-96 96-96z"/>
    </svg>
    <div className="facts-text">
      <h3 data-toggle="counter-up">1500+</h3>
      <p>People Benefited</p>
    </div>
  </div>
</div>
                        <div className="col-lg-3 col-md-6">
                            <div className="facts-item">
                               <svg 
    height={isMobile ? 35 : 70} 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 640 512">
    <path fill="#FFD43B" d="M320 32L0 160l320 128 256-102.4V352h64V160L320 32zm0 256L128 192v64c0 70.7 85.3 128 192 128s192-57.3 192-128v-64L320 288z"/>
</svg>
                               
                                <div className="facts-text">
                                    <h3 className="" data-toggle="counter-up">1000+</h3>
                                    <p>Women Trained</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}